import { Injectable, signal } from '@angular/core';

export enum Shopfilter {
  isTopShop = 'isTopShop',
  isDiscountShop = 'isDiscountShop',
  hasDepot = 'hasDepot',
  hasModelchange = 'hasModelchange',
  hasFreeChildren = 'hasFreeChildren',
  hasDelivery = 'isVirtualShop'
}

@Injectable({
  providedIn: 'root'
})
export class ShopFilterService {
  distance = signal(100);
  activeFilters = signal([]);
  // since there's no filter active on mobile, the default distance needs to be big enough to never filter a shop
  maxDistance = 100;
  minDistance = 1;

  constructor() {}

  /**
   * Will not update filteredShops and can be used independetly
   * filters and returns given
   * @param elements filtered by
   * @param distance in Kilometers and
   * @param filters that should be truthy
   * @returns filtered Array.
   */
  filterBy<T extends { distance: number; inTown: boolean }>(
    elements: T[],
    distance: number | null,
    filters: Shopfilter[],
    includingActive = false
  ): T[] {
    if (includingActive) {
      filters = [...filters, ...this.activeFilters()];
    }
    const filteredElements = elements.filter(e => {
      const allow = distance === 0 || e.distance <= distance || e.inTown;
      if (allow) {
        for (let i = 0; i < filters.length; i++) {
          if (!e[filters[i]]) {
            return false;
          }
        }
      }
      return allow;
    });
    return filteredElements;
  }

  /**
   * activate or deactivate the given filter. Will update the filteredShops
   * by given
   * @param filter Filter you updated
   * @param forElements you want to filter
   */
  toggleFilters(filters: Shopfilter[]) {
    const activeFilters = [...this.activeFilters()];
    filters.forEach(filter => {
      const index = activeFilters.indexOf(filter);
      if (index !== -1) {
        activeFilters.splice(index, 1);
      } else {
        activeFilters.push(filter);
      }
    });
    this.activeFilters.set(activeFilters);
  }

  /**
   * update the distance filter to the given value. Will update the filteredShops
   * by given
   * @param distance in kilometer
   * @param forElements you want to filter
   */
  changeDistance(distance: number) {
    if (distance !== this.distance()) {
      this.distance.set(distance);
    }
  }
}
